import * as React from 'react';
import { ActivityAction, ActivityResourceName } from '@pec/aion-ui-core/interfaces/activities';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { Error } from '../../components/Error';
import { ContractorManagementSectionComponent } from '../../components/Nav/ContractorManagementSection';
import { Loading } from '../../components/Loading';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { IOrganization } from '@pec/aion-ui-core/interfaces/organization';
import { DeepReadonly } from 'utility-types';
import { fetchPendingReleasesCount } from '@pec/aion-ui-core/actions/fetchPendingReleasesCount';
import { hasPermission } from '@pec/aion-ui-core/actions/userInfo';
import { UserInfoActivitiesType } from '@pec/aion-ui-core/interfaces/userInfo';

type OwnProps = {
  organization: DeepReadonly<IOrganization>;
};

const mapStateToProps = (state: CommonRootState) => ({
  ...state.organization,
  ...state.userInfo,
  pendingReleasesCount: state.notifications.pendingReleasesCount
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<CommonRootState, null, RootActions>,
  { organization }: OwnProps
) => ({
  getPendingReleaseCount: () => organization && organization.id && dispatch(fetchPendingReleasesCount(organization.id))
});

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps;

class SubcontractorManagement extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.getPendingReleaseCount();
  }

  hasGlobalPermission = (action: ActivityAction, resourceName: ActivityResourceName) =>
    hasPermission(this.props.userInfo, action, resourceName);

  hasOrganizationPermission = (action: ActivityAction, resourceName: ActivityResourceName) => {
    const { userInfo, organization } = this.props;

    return organization && organization.id
      ? hasPermission(userInfo, action, resourceName, [
          {
            type: UserInfoActivitiesType.Organization,
            id: organization.id
          }
        ])
      : false;
  };

  render() {
    const { organization, isFetching, fetchError, pendingReleasesCount } = this.props;
    const { features } = organization;

    return !isFetching && !fetchError ? (
      <ContractorManagementSectionComponent
        hasGlobalPermission={this.hasGlobalPermission}
        hasOrganizationPermission={this.hasOrganizationPermission}
        features={features}
        organizationId={organization.id}
        pendingReleasesCount={pendingReleasesCount}
      />
    ) : fetchError ? (
      <Error />
    ) : (
      <Loading />
    );
  }
}

export const ContractorManagementSectionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SubcontractorManagement);
